import css from 'styled-jsx/css';
import { colorHighlight, sansSerif, serif } from 'styles/css-constants';
import { MQ_MEDIUM } from 'constants/mq';
import { sharedPalette, warmGrays } from 'styles/colors/constants';

export default css`
  .Product--in-post {
    position: relative;
    display: flex;
    flex-direction: column;
    text-decoration: none;
  }

  .Product--in-post .Product__body {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
  }

  .Product__content-link {
    display: block;
    width: 100%;
  }

  .Product--in-post .Product__cake {
    align-self: flex-start;
    margin-bottom: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    min-width: 64px;
    padding: 0 1rem;
    background-color: ${sharedPalette.darkWatermelon};
    color: #fff;
    font-size: 0.78125rem;
    letter-spacing: 0.02em;
    line-height: 1;
    text-transform: uppercase;
  }

  .Product--in-post .Product__cta,
  .Product--in-post .Product__price,
  .Product--in-post .Product__retailer {
    display: block;
    font-family: ${sansSerif};
  }

  .Product--in-post .Product__cta {
    flex: 0 0 auto;
    display: inline-block;
    border-bottom: 1px solid #000;
    color: #000;
    font-size: var(--baseFontSize);
    font-weight: bold;
    letter-spacing: 0.02em;
    text-transform: uppercase;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .Product--in-post .Product__description {
    color: #000;
    display: block;
    margin-bottom: 1rem;
  }

  .Product--in-post .Product__description :global(a) {
    border-bottom: 1px solid ${colorHighlight};
    color: #000;
  }

  .Product--in-post .Product__image {
    margin-bottom: 1rem;
  }

  .Product--in-post .Product__name,
  .Product--in-post .Product__price,
  .Product--in-post .Product__retailer {
    flex: 0 0 100%;
  }

  .Product--in-post .Product__name {
    margin-bottom: 0.5rem;
    color: #000;
    font-family: ${serif};
    font-size: var(--fontScale2);
    font-weight: 700;
  }

  .Product--in-post .Product__price {
    margin-bottom: 0.25rem;
    color: #000;
    font-size: var(--fontScale1);
  }

  .Product--in-post .Product__original-price {
    margin-right: 0.5rem;
    display: inline-block;
    color: ${warmGrays[6]};
    text-decoration: line-through;
  }

  .Product--in-post .Product__retailer {
    margin-bottom: 1rem;
    color: ${warmGrays[6]};
    font-size: var(--fontScaleNeg2);
    text-transform: uppercase;
  }

  .Product--in-post .Product__saveToWishList {
    flex: 0 0 auto;
  }

  @media screen and ${MQ_MEDIUM} {
    .Product--in-post {
      flex-direction: row;
    }

    .Product--in-post .Product__body {
      flex: 0 0 50%;
      align-content: flex-start;
      padding-left: 1rem;
    }

    .Product--in-post .Product__cake {
      position: absolute;
      top: 0;
      right: auto;
      left: calc(50% + 1rem);
      height: 40px;
      min-width: 86px;
      font-size: 0.875rem;
    }

    /* Add padding when the sponsored seal is there to move copy down */
    .Product--in-post .Product__cake + .Product__body {
      padding-top: calc(40px + 1rem);
    }

    .Product--in-post .Product__cta {
      font-size: var(--baseFontSize);
    }

    .Product--in-post .Product__image {
      flex: 0 0 50%;
      margin-bottom: 0;
    }

    .Product--in-post .Product__price {
      font-size: var(--fontScale1);
    }

    .Product--in-post .Product__retailer {
      margin-bottom: 2.25rem;
      font-size: var(--fontScaleNeg1);
    }
  }
`;
